// @flow

import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';
import { normalizePhone, validatePhone } from './validate-phone';

type InputProps = {
  // Our configurations
  onError?: (error: string | null) => void;

  // Configurations that are on both, but that we override
  value?: string | null;
  onChange: (phoneNumber: string | null) => void;

  // Added by React
  innerRef?: any;
};

type Props = InputProps & {
  label?: string,
  required?: boolean,
  error?: boolean,
  helperText?: string,
};

export const UiPhoneTextField = ({
  label,
  required,
  value,
  onChange,
  onError,
  error,
  helperText,
  ...textFieldProps
}: Props) => {
  const [phoneError, setPhoneError] = useState<string | null>(null);

  let displayValue = value || '';
  const e164Test = /^\+1([\d]{10})$/g.exec(displayValue);
  if (e164Test) {
    displayValue = e164Test[1] || '';
  }
  displayValue = normalizePhone(displayValue) || '';

  const onBlurHandler = () => {
    if (!required && !value) {
      setPhoneError(null);
      if (onError) {
        onError(null);
      }
    }
  };

  const phoneNumberOnChangeHandler = (e: any) => {
    const newPhoneNumber = e.target.value;

    const numbersInValue = newPhoneNumber.replace(/[^\d]/g, '');
    if (numbersInValue.length > 10) {
      return;
    }

    const normalizedPhone = normalizePhone(newPhoneNumber);
    onChange(normalizedPhone);

    if (setPhoneError) {
      const phoneErrorTest = validatePhone(normalizedPhone);
      if (phoneErrorTest) {
        setPhoneError(phoneErrorTest);
        if (onError) {
          onError(phoneErrorTest);
        }
      } else {
        setPhoneError(null);
        if (onError) {
          onError(null);
        }
      }
    }
  };

  return (
    // Flow hates the in-exact spread, but it's exactly what we want here
    // $flow-disable-next-line
    <TextField
      value={displayValue}
      onChange={phoneNumberOnChangeHandler}
      onBlur={onBlurHandler}
      error={Boolean(phoneError) || error}
      helperText={phoneError || helperText}
      // Passthrough options
      label={label || 'Phone Number'}
      required={required}
      {...textFieldProps}
    />
  );
};
